<!--  -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.khl_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <router-link to="/bbsen" class="lit01_b">{{text.bbs1}}</router-link>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.bbs1}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <div class="cont_r_b31">
                <ul class="lit07">
                  <li class="lit07_a">
                    <div class="cont_r_b32">
                      <p>{{text.bbs01}}</p>
                    </div>
                    <div class="cont_r_b33">
                      <input name="name" type="text" id="name" maxlength="10" v-model="xmv">
                    </div>
                    <div class="cont_r_b34">
                      <p>
                        <span id="RequiredFieldValidator1" style="visibility:hidden;">*</span>
                      </p>
                    </div>
                    <div class="cont_r_b35">
                      <p>{{text.bbs02}}</p>
                    </div>
                  </li>
                  <li class="lit07_a">
                    <div class="cont_r_b32">
                      <p>{{text.bbs03}}</p>
                    </div>
                    <div class="cont_r_b33">
                      <input name="shouji" type="text" id="shouji" maxlength="11" v-model="sjv">
                    </div>
                    <div class="cont_r_b34">
                      <p>
                        <span id="RequiredFieldValidator2" style="visibility:hidden;">*</span>
                      </p>
                    </div>
                    <div class="cont_r_b35">
                      <p>{{text.bbs04}}</p>
                    </div>
                  </li>
                  <li class="lit07_a">
                    <div class="cont_r_b32">
                      <p>{{text.bbs05}}</p>
                    </div>
                    <div class="cont_r_b33">
                      <input
                        name="youxiang"
                        type="text"
                        id="youxiang"
                        maxlength="100"
                        v-model="yxv"
                      >
                    </div>
                    <div class="cont_r_b34">
                      <p>
                        <span id="RequiredFieldValidator3" style="visibility:hidden;">*</span>
                      </p>
                    </div>
                    <div class="cont_r_b35">
                      <p>{{text.bbs06}}</p>
                    </div>
                  </li>
                  <li class="lit07_a">
                    <div class="cont_r_b32">
                      <p>{{text.bbs07}}</p>
                    </div>
                    <div class="cont_r_b33">
                      <input name="dizhi" type="text" id="dizhi" maxlength="100" v-model="dzv">
                    </div>
                    <div class="cont_r_b34">
                      <p>
                        <span id="RequiredFieldValidator4" style="visibility:hidden;">*</span>
                      </p>
                    </div>
                    <div class="cont_r_b35">
                      <p>{{text.bbs08}}</p>
                    </div>
                  </li>
                  <li class="lit07_a">
                    <div class="cont_r_b32">
                      <p>{{text.bbs09}}</p>
                    </div>
                    <div class="cont_r_b33">
                      <input name="youbian" type="text" id="youbian" maxlength="20" v-model="ybv">
                    </div>
                    <div class="cont_r_b34">
                      <p>
                        <span id="RequiredFieldValidator5" style="visibility:hidden;">*</span>
                      </p>
                    </div>
                    <div class="cont_r_b35">
                      <p>{{text.bbs10}}</p>
                    </div>
                  </li>
                </ul>
                <div class="cont_r_b36">
                  <div class="cont_r_b32">
                    <p>{{text.bbs11}}</p>
                  </div>
                  <div class="cont_r_b38">
                    <textarea
                      name="nr"
                      id="nr"
                      rows="6"
                      cols="50"
                      style="resize:none"
                      v-model="lyv"
                    ></textarea>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
              <div class="cont_r_b39">
                <div class="cont_r_b43">
                  <input
                    type="image"
                    name="ImageButton1"
                    id="ImageButton1"
                    :src="images.dji_07"
                    @click="tj"
                  >
                </div>
                <div class="cont_r_b44">
                  <input type="image" :src="images.cz_09" @click="cz">
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xmv: "",
      sjv: "",
      yxv: "",
      dzv: "",
      ybv: "",
      lyv: "",
      text: {
        product3: "Aluminum Coil/Aluminum Plate/Aluminum Foil/CanBody",
        product4: "Remelt Lead Ingot/Remelt Zinc Ingot",
        bbs1: "FEEDBACK",
        bbs01: "Name",
        bbs02: "Please fill in your real name.",
        bbs03: "Phone",
        bbs04: "Mobile phone with you the most important way.",
        bbs05: "E-mail",
        bbs06: "Please fill in the correct mailbox.",
        bbs07: "Address",
        bbs08: "An important way to contact you.",
        bbs09: "Postcode",
        bbs10: "In order to ensure data delivery.",
        bbs11: "Massage"
      },
      images: {
        khl_03: require("../../../assets/img/en/khl_03.jpg"),
        dji_07: require("../../../assets/img/en/dji_07.jpg"),
        cz_09: require("../../../assets/img/en/cz_09.jpg")
      }
    };
  },

  components: {},

  methods: {
    cz() {
      this.xmv = "";
      this.sjv = "";
      this.yxv = "";
      this.dzv = "";
      this.ybv = "";
      this.lyv = "";
    },
    tj() {
      this.$http
        .post(
          "SSM-master/userMessage/submitMessage",
          {
            realname: this.xmv,
            telephone: this.sjv,
            email: this.yxv,
            address: this.dzv,
            postCode: this.ybv,
            message: this.lyv
          }
        )
        .then(response => {
          alert("Ok");
          response => {
            console.log("出错了");
          };
        });
    }
  }
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/bbs/bbs.vue